/* eslint-disable */
var webPushNotifications = require('./dist/web-push-notifications');

module.exports = webPushNotifications;
